'use client';

import { BASE_TF_URL } from '@/requests/constants';
import { Button } from '../ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../ui/card';
import { LockIcon } from 'lucide-react';
import { useSignOut } from '@/providers/session-provider/hooks/use-sign-out';
import { useSession } from '@/providers/session-provider';

export function ExternalUserForbiddenOverlay() {
  const {
    data: { user },
  } = useSession();

  const signOut = useSignOut();

  if (!user || user.detailAccess !== 2) {
    return null;
  }

  return (
    <div className='fixed inset-0 z-1000 flex min-h-screen items-center justify-center bg-surface'>
      <Card>
        <CardContent className='max-w-lg'>
          <CardHeader>
            <CardTitle className='flex items-center gap-1'>
              <LockIcon className='size-4' />
              Du saknar behörighet att använda denna sida
            </CardTitle>
          </CardHeader>
          <CardDescription className='mt-2 mb-4'>
            Du är en extern användare och saknar behörighet att använda
            webbportalen. Vänligen använd appen för teknisk förvaltning
            istället.
          </CardDescription>

          <div className='grid grid-cols-2 gap-2'>
            <Button
              variant='secondary'
              onClick={() => {
                signOut();
              }}
            >
              Logga ut
            </Button>
            <Button asChild>
              <a href={BASE_TF_URL}>Gå till app för teknisk förvaltning</a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
